import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";

@Component({
  selector: 'edsng-basic-card',
  templateUrl: './basic-card.component.html',
  styleUrls: ['./basic-card.component.css']
})
export class BasicCardComponent implements OnInit {

  @Input() labelHeader: string = '';
  @Input() labelLink: string = '';
  @Input() imgSrc: string = null;
  @Output() clickAction: EventEmitter<void> = new EventEmitter<void>();
  constructor() {
  }

  ngOnInit() {
  }

  clickCard() {
    if (this.clickAction) { this.clickAction.emit(); }
  }
}
